(() => {
  const init = (header) => {
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    const section = header.closest('.shopify-section');
    const messages = [...header.querySelectorAll('.lp-announcement__messages span')];
    let messageIndex = 0;
    if (messages.length > 1) setInterval(() => { messages[messageIndex].classList.remove('is-active'); messageIndex = (messageIndex + 1) % messages.length; messages[messageIndex].classList.add('is-active'); }, 3500);

    const closeMegas = () => {
      header.querySelectorAll('[data-lp-mega-panel]').forEach(panel => panel.hidden = true);
      header.querySelectorAll('[data-lp-mega]').forEach(button => button.classList.remove('is-active'));
    };
    header.querySelectorAll('[data-lp-mega]').forEach(button => {
      const name = button.dataset.lpMega;
      const panel = header.querySelector(`[data-lp-mega-panel="${name}"]`);
      const open = () => { const wasOpen = panel && !panel.hidden; closeMegas(); if (panel && !wasOpen) { panel.hidden = false; button.classList.add('is-active'); } };
      button.addEventListener('mouseenter', open);
      button.addEventListener('click', open);
    });
    header.querySelector('.lp-nav')?.addEventListener('mouseleave', e => { if (!e.relatedTarget?.closest?.('.lp-mega')) closeMegas(); });
    header.querySelectorAll('.lp-mega').forEach(panel => panel.addEventListener('mouseleave', closeMegas));

    const drawer = header.querySelector('[data-lp-drawer]');
    const overlay = header.querySelector('[data-lp-overlay]');
    const menuButton = header.querySelector('[data-lp-menu-open]');
    const setDrawer = (open) => { drawer?.classList.toggle('is-open', open); overlay?.classList.toggle('is-open', open); drawer?.setAttribute('aria-hidden', String(!open)); menuButton?.setAttribute('aria-expanded', String(open)); document.body.classList.toggle('lp-menu-open', open); };
    menuButton?.addEventListener('click', () => setDrawer(true));
    header.querySelector('[data-lp-menu-close]')?.addEventListener('click', () => setDrawer(false));
    overlay?.addEventListener('click', () => setDrawer(false));

    const input = header.querySelector('[data-lp-search-input]');
    const predictive = header.querySelector('[data-lp-predictive]');
    const resultGrid = header.querySelector('[data-lp-results]');
    const viewAll = header.querySelector('[data-lp-view-all]');
    let timer;
    const closeSearch = () => { predictive.hidden = true; header.classList.remove('search-open'); };
    const showResults = (products, query) => {
      resultGrid.innerHTML = '';
      if (!products.length) resultGrid.innerHTML = '<p>No products found.</p>';
      products.slice(0, 5).forEach(product => {
        const item = document.createElement('a'); item.className = 'lp-result'; item.href = product.url;
        const image = product.image || product.featured_image?.url || '';
        const price = product.price || product.price_min || '';
        item.innerHTML = `${image ? `<img src="${image}" alt="" loading="lazy">` : ''}<strong>${product.title}</strong><span>${price}</span>`;
        resultGrid.appendChild(item);
      });
      viewAll.href = `/search?q=${encodeURIComponent(query)}&type=product`;
      predictive.hidden = false; header.classList.add('search-open');
    };
    input?.addEventListener('focus', () => { if (input.value.trim().length > 1) predictive.hidden = false; });
    input?.addEventListener('input', () => {
      clearTimeout(timer); const query = input.value.trim(); if (query.length < 2) { closeSearch(); return; }
      timer = setTimeout(async () => {
        try {
          const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`);
          const data = await response.json(); showResults(data.resources?.results?.products || [], query);
        } catch (_) { predictive.hidden = false; header.classList.add('search-open'); resultGrid.innerHTML = '<p>Press enter to search.</p>'; }
      }, 220);
    });
    header.querySelector('[data-lp-search-close]')?.addEventListener('click', closeSearch);
    document.addEventListener('click', event => { if (!event.target.closest('[data-lp-search-shell]')) closeSearch(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeSearch(); closeMegas(); setDrawer(false); } });

    const stickyPoint = header.offsetTop + 40;
    const onScroll = () => section?.classList.toggle('is-sticky', window.scrollY > stickyPoint);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  };
  document.querySelectorAll('[data-lp-header]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-lp-header]')));
})();
